import { useMutation } from '@tanstack/react-query';

import axios from '@/portainer/services/axios';
import { EnvironmentId } from '@/react/portainer/environments/types';
import { queryClient, withInvalidate } from '@/react-tools/react-query';
import { userQueryKeys } from '@/portainer/users/queries/queryKeys';
import { teamQueryKeys } from '@/react/portainer/users/teams/queries/query-keys';

import { configMapQueryKeys } from '../../configs/queries/query-keys';
import { PortainerNamespaceAccessesConfigMap } from '../../configs/constants';

export type UpdateNamespaceAccessesPayload = {
  UsersToAdd: number[];
  TeamsToAdd: number[];
  UsersToRemove: number[];
  TeamsToRemove: number[];
};

export function useUpdateNamespaceAccessesMutation(
  environmentId: EnvironmentId,
  namespaceName: string
) {
  return useMutation({
    mutationFn: (payload: UpdateNamespaceAccessesPayload) =>
      updateNamespaceAccesses(environmentId, namespaceName, payload),
    ...withInvalidate(queryClient, [
      configMapQueryKeys.configMap(
        environmentId,
        PortainerNamespaceAccessesConfigMap.namespace,
        PortainerNamespaceAccessesConfigMap.configMapName
      ),
      userQueryKeys.base(),
      teamQueryKeys.base(),
    ]),
  });
}

async function updateNamespaceAccesses(
  environmentId: EnvironmentId,
  namespaceName: string,
  payload: UpdateNamespaceAccessesPayload
) {
  return axios.put(
    `/endpoints/${environmentId}/pools/${namespaceName}/access`,
    payload
  );
}
